const PaidServices = () => {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Платные образовательные услуги</h2>
      <ul className="space-y-3">
        <li><a href="/documents/contract.pdf" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">📑 Образец договора</a></li>
        <li><a href="/documents/price-order.pdf" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">💰 Приказ об утверждении стоимости обучения</a></li>
      </ul>
    </div>
  );
};

export default PaidServices;
